import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTimeSometimesGlyphSecondary from './svgs/TimeSometimesGlyphSecondary.js';
import SvgTimeSometimesGlyph from './svgs/TimeSometimesGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var timeSometimesGlyph = (props => useIcon(SvgTimeSometimesGlyph, SvgTimeSometimesGlyphSecondary, props));

export { timeSometimesGlyph as default };
